import type { ColorTokens } from "tamagui";
import { View } from "tamagui";
export const BAR_HEIGHT = 10;
type BarProps = {
  /** Fixed pill width. Mutually exclusive with `flex`. */
  width?: number;
  /** Stretch to fill the available row width. */
  flex?: boolean;
  color?: ColorTokens;
};

// The placeholder "text line" pill shared by the bill and claim-check cards.
export const Bar = ({
  width,
  flex,
  color = "$surface0Hover"
}: BarProps) => <View height={BAR_HEIGHT} width={width} flex={flex ? 1 : undefined} borderRadius="$brFull" backgroundColor={color} data-sentry-element="View" data-sentry-component="Bar" data-sentry-source-file="Bar.tsx" />;